<template>
  <div class="datepicker-trigger">
    <label for="datepicker-trigger" class="sr-only">
      {{ $t('message.testDrive.chooseDateSubheader1') }}
    </label>
    <input
      type="text"
      id="datepicker-trigger"
      placeholder="YYYY/MM/DD"
      :value="formatDate(dateOne)"
      name="dateRange"
      class="date-picker-input d-block d-md-inline-block"
    />
    <AirbnbStyleDatepicker
      class="date-picker"
      :trigger-element-id="'datepicker-trigger'"
      :mode="'single'"
      :fullscreen-mobile="false"
      :date-one="dateOne"
      @date-one-selected="
        val => {
          dateOne = val;
        }
      "
      :offset-y="38"
      :offset-x="-17"
      :monthsToShow="1"
      :showShortcutsMenuTrigger="false"
      :min-date="currentDay"
      :end-date="twoWeeksFromNow"
    >
    </AirbnbStyleDatepicker>
    <img class="arrow-down" src="@/assets/fa/chevron-down.svg" alt="Dropdown arrow" />
  </div>
</template>

<script>
import format from 'date-fns/format';
import moment from 'moment';

export default {
  data() {
    return {
      dateFormat: 'YYYY/MM/D',
      dateOne: '',
      currentHour: moment().format('HH'),
    };
  },
  watch: {
    dateOne() {
      this.onClickButton();
    },
  },
  computed: {
    currentDay() {
      if (this.currentHour > 21) {
        return moment().add(1, 'days').format('YYYY-MM-DD');
      }
      return moment().format('YYYY-MM-DD');
    },
    twoWeeksFromNow() {
      if (this.currentHour > 21) {
        return moment().add(14, 'days').format('YYYY-MM-DD');
      }
      return moment().add(13, 'days').format('YYYY-MM-DD');
    },
  },
  methods: {
    formatDate(dateOne) {
      let formattedDates = '';
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      return formattedDates;
    },
    onClickButton() {
      this.$emit('clicked', this.formatDate(this.dateOne));
    },
  },
};
</script>
<style lang="scss" scoped>
.arrow-down {
  z-index: 0;
  position: absolute;
  display: block;
  width: 12px;
  height: 15px;
  right: 35px;
  top: 24px;
  transition: all 0.4s ease;
  pointer-events: none;
}
.date-picker {
  border: transparent;
}
.date-picker-input {
  border: transparent;
  width: 180px;
  height: 50px;
  margin: 8px 0 4px 12px !important;
  padding: 0 !important;
}
.datepicker-trigger {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
